import React from "react";
import { Outlet } from "react-router-dom";
import CommonHeader from "./CommonHeader";

const LayoutEmployee = () => {
  return (
    <>
      <CommonHeader />
      <Outlet />
    </>
  );
};

export default LayoutEmployee;
